import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/de';
import 'dayjs/locale/en';

// Date pipes must work without importing the application setup entry point.
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);

export default dayjs;
